import { SMART_FLAG_PROFILE_RESET } from "../actions";

const getErrorMessage = action => action?.error?.response?.data?.errors
  || action?.error?.response?.data?.title
  || action?.error?.response?.statusText
  || action?.error?.message
  || "Unable to load the Smart Flag profile.";

export const SMART_FLAG_PROFILES_GET_SUCCESS = 'SMART_FLAG_PROFILES_GET_SUCCESS'
export const SMART_FLAG_PROFILES_GET_FAIL = 'SMART_FLAG_PROFILES_GET_FAIL'
export const SMART_FLAG_PROFILE_DETAIL_GET_SUCCESS = 'SMART_FLAG_PROFILE_DETAIL_GET_SUCCESS'
export const SMART_FLAG_PROFILE_DETAIL_GET_FAIL = 'SMART_FLAG_PROFILE_DETAIL_GET_FAIL'
export const SMART_FLAG_PROFILE_CREATE_SUCCESS = 'SMART_FLAG_PROFILE_CREATE_SUCCESS'
export const SMART_FLAG_PROFILE_CREATE_FAIL = 'SMART_FLAG_PROFILE_CREATE_FAIL'
export const SMART_FLAG_PROFILE_UPDATE_SUCCESS = 'SMART_FLAG_PROFILE_UPDATE_SUCCESS'
export const SMART_FLAG_PROFILE_UPDATE_FAIL = 'SMART_FLAG_PROFILE_UPDATE_FAIL'
export const SMART_FLAG_PROFILE_DELETE_SUCCESS = 'SMART_FLAG_PROFILE_DELETE_SUCCESS'
export const SMART_FLAG_PROFILE_DELETE_FAIL = 'SMART_FLAG_PROFILE_DELETE_FAIL'
export const SMART_FLAG_PROFILE_SET_DEFAULT_SUCCESS = 'SMART_FLAG_PROFILE_SET_DEFAULT_SUCCESS'
export const SMART_FLAG_PROFILE_SET_DEFAULT_FAIL = 'SMART_FLAG_PROFILE_SET_DEFAULT_FAIL'

export const defaultSmartFlagProfileState = {
  profiles: [],
  profileDetail: null,
  loading: false,
  error: false,
  errorMessage: null,
};

export default (state = defaultSmartFlagProfileState, action) => {
  switch (action.type) {
    case SMART_FLAG_PROFILES_GET_SUCCESS:
      return {
        ...state,
        profiles: action.payload.data,
        loading: false,
        error: false,
        errorMessage: null,
      };
    case SMART_FLAG_PROFILES_GET_FAIL:
      return {
        ...state,
        profiles: [],
        loading: false,
        error: true,
        errorMessage: getErrorMessage(action),
      };
    case SMART_FLAG_PROFILE_DETAIL_GET_SUCCESS:
      return {
        ...state,
        profileDetail: action.payload.data,
        loading: false,
        error: false,
        errorMessage: null,
      };
    case SMART_FLAG_PROFILE_DETAIL_GET_FAIL:
      return {
        ...state,
        profileDetail: null,
        loading: false,
        error: true,
        errorMessage: getErrorMessage(action),
      };
    case SMART_FLAG_PROFILE_CREATE_SUCCESS:
    case SMART_FLAG_PROFILE_UPDATE_SUCCESS:
    case SMART_FLAG_PROFILE_DELETE_SUCCESS:
    case SMART_FLAG_PROFILE_SET_DEFAULT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        errorMessage: null,
      };
    case SMART_FLAG_PROFILE_CREATE_FAIL:
    case SMART_FLAG_PROFILE_UPDATE_FAIL:
    case SMART_FLAG_PROFILE_DELETE_FAIL:
    case SMART_FLAG_PROFILE_SET_DEFAULT_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        errorMessage: getErrorMessage(action),
      };
    case SMART_FLAG_PROFILE_RESET:
      return {
        ...state,
        profileDetail: null,
        error: false,
        errorMessage: null,
      };
    default:
      return {
        ...state
      };
  }
}
